export default __webpack_public_path__ + "static/professor-5-00d76bd98246c7ab7cc6697f5f0a00d8.png";